//generated by docker file 
export const URL = "https://licitacoes.caruaru.pe.gov.br:8082/";




// WEBPACK FOOTER //
// ./src/app/_mocks/url.ts